import React from "react";
import { IoMdCloseCircle, IoMdCloseCircleOutline } from "react-icons/io";
import Logo from "../../Assets/Logos/yostelLogo.svg";
import img1 from "../../Assets/UserSide/Popup/img1.png";
import img2 from "../../Assets/UserSide/Popup/img2.png";
import img3 from "../../Assets/UserSide/Popup/img3.png";
import img4 from "../../Assets/UserSide/Popup/img4.png";
import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const PopuUpModal = ({ onClose }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    location: "",
    type: "Call",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    setLoading(true);

    if (!form.name || !form.phone) {
      return toast.error("Name and Phone number are required");
    }

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/lead/create-lead`,
      maxBodyLength: Infinity,
      data: form,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of handleSubmit(Lead): ", response.data);
        toast.success("Your query recorded. We'll reach you out soon.");
        onClose();
      })
      .catch((error) => {
        console.log("Error in handleSubmit: ", error);
        toast.error("Something went wrong. Please try again later.");
      });
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative h-auto md:h-[28rem] lg:h-auto overflow-y-scroll md:overflow-y-auto bg-white rounded-lg shadow-lg w-full max-w-[90%] lg:max-w-[90%] xl:max-w-[70%] grid grid-cols-1 md:grid-cols-2">
        <div className="p-8 hidden md:block flex-1">
          <img src={Logo} alt="" className="w-32 mb-4" />
          <h1 className="text-xl text-[#1C1C1C] font-bold w-[90%] mb-2 tracking-wide">
            Looking for a fully furnished, secure PG where you feel part of a
            community — without giving up your personal space?
          </h1>
          <p className="text-[#7B7B7B] text-sm mb-4">
            At Yostel, you've found your second home. Welcome.
          </p>

          <div className="flex flex-col gap-3">
            <div className="bg-[#D7EDFF] flex p-2 items-center gap-4 rounded-lg">
              <img src={img1} alt="" />
              <p className="text-[#383838] font-semibold tracking-wide">
                Fully furnished rooms
              </p>
            </div>
            <div className="bg-[#B2DBFF] flex p-2 items-center gap-4 rounded-lg">
              <img src={img2} alt="" />
              <p className="text-[#383838] font-semibold tracking-wide">
                Safe, secure and hygienic living
              </p>
            </div>
            <div className="bg-[#97CFFF] flex p-2 items-center gap-4 rounded-lg">
              <img src={img3} alt="" />
              <p className="text-[#383838] font-semibold tracking-wide">
                Vibrant community with personal freedom
              </p>
            </div>
            <div className="bg-[#79C1FF] flex p-2 items-center gap-4 rounded-lg">
              <img src={img4} alt="" />
              <p className="text-[#383838] font-semibold tracking-wide">
                Prime locations near your college or workplace
              </p>
            </div>
          </div>
        </div>

        <div className="bg-[#004B8B] p-4 md:p-8 flex-1">
          <h1 className="text-lg text-white font-semibold w-full md:hidden mb-2 tracking-wide">
            Looking for a fully furnished, secure PG where you feel part of a
            community — without giving up your personal space?
          </h1>
          <p className="text-gray-300 text-sm mb-4 md:hidden">
            At Yostel, you've found your second home. Welcome.
          </p>
          <div className="flex flex-col gap-2 md:mt-8">
            <label
              htmlFor=""
              className="text-white font-semibold text-md md:text-lg tracking-wide"
            >
              Name
            </label>
            <input
              type="text"
              className="px-4 py-2 md:py-3 bg-white/20 border border-white outline-none rounded-lg text-white"
              placeholder="Enter your name"
              value={form.name}
              onChange={(e) =>
                setForm({
                  ...form,
                  name: e.target.value,
                })
              }
            />
          </div>

          <div className="flex flex-col gap-2 mt-4 md:mt-8">
            <label
              htmlFor=""
              className="text-white font-semibold text-md md:text-lg tracking-wide"
            >
              Mobile No
            </label>
            <input
              type="text"
              className="px-4 py-2 md:py-3 bg-white/20 border border-white outline-none rounded-lg text-white"
              placeholder="Mobile Number"
              value={form.phone}
              onChange={(e) =>
                setForm({
                  ...form,
                  phone: e.target.value,
                })
              }
            />
          </div>

          <div className="flex flex-col gap-2  mt-4  md:mt-8">
            <label
              htmlFor=""
              className="text-white font-semibold text-md md:text-lg tracking-wide"
            >
              Location you're searching for
            </label>
            <input
              type="text"
              className="px-4 py-2 md:py-3 bg-white/20 border border-white outline-none rounded-lg text-white"
              placeholder="Location"
              value={form.location}
              onChange={(e) =>
                setForm({
                  ...form,
                  location: e.target.value,
                })
              }
            />
          </div>

          <button
            className="bg-white text-lg p-2 w-full rounded  text-center mt-6 md:mt-10 font-semibold text-[#0465B9] shadow-xl"
            onClick={handleSubmit}
          >
            {loading ? "Submitting..." : "Find My Stay"}
          </button>
        </div>

        <IoMdCloseCircle
          className="absolute top-2 right-2 text-white cursor-pointer"
          size={32}
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default PopuUpModal;
